import React,{useState,useEffect} from 'react'
import ScElement from "./ScElement";
//import {useSelector} from 'react-redux' //remove
import {ScItemTypes} from '../ScItemTypes'
import {useDrop} from 'react-dnd'
import { useEyeconxStore } from '../../../../store/eyeconxStore';
import Loading from '../../../common/Loading';
const ScCanvas = () => {
   // const cards = useSelector((state)=>state.survey.data)
   const cards = useEyeconxStore((state)=>state.survey.data)
   const [loading,setLoading] = useState(true)

    useEffect(()=>{
        console.log("Cards")
        console.log(cards)
        setLoading(true)
        setTimeout(()=>{
            setLoading(false)
        },3000)
    },[])

    const [{},drop] = useDrop(()=>({
        accept: ScItemTypes.TOOLBUTTON,
        drop:()=>({name:'Canvas'}),
        collect:(monitor)=>({
            isOver:monitor.isOver(),
            canDrop:monitor.canDrop(),
        }),
    }))
   
    return ( 
        <div className="card" style={{height:"90vh",overflow:'auto'}} ref={drop}>
        <div className="card-body">
            {loading ? <Loading/>:
              <div className="row mt-2 p-3 " >
                  {cards.length >0 &&
                    cards.map((card,index)=>(
                        <ScElement
                            key={card.id}
                            element={card}
                            index={index}
                            id={card.id}

                        />
                    )) 
                    }
              </div>
                }
        </div>
    </div>
     );
}
 
export default ScCanvas;